import React, { useState } from 'react';
import { useNavigate, useOutlet } from 'react-router-dom';
import styled from 'styled-components';
import AlertModal from '../../components/modal/AlertModal';
import OrderController from '../../controller/OrderController';
import StoreController, { CurrentStoreContext } from '../../controller/StoreController';
import { useOutletContext } from 'react-router-dom';
import toast from 'react-hot-toast';

const StoreTestOrder = () => {
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const storeId = currentStore.value;
  const [authenticationErrorModal, setAuthenticationErrorModal] = React.useState<boolean>(false);

  const testOrder = async () => {
    try {
      const data = {
        store_id: storeId,
      };
      const oRes = await OrderController.selfTestOrder(data);
      if (oRes && oRes.data) {
        const oResponse = oRes.data;

        if (oResponse.data && oResponse.ok) {
          toast.success('테스트 주문이 완료되었습니다.\n포스를 확인해주세요.');
          setAuthenticationErrorModal(false);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  return (
    <>
      <Style>
        <div className="contentContainer">
          <h1>셀프입점 온보딩 테스트 주문</h1>
          <h2>
            ⚠️이 주문은 테스트 주문입니다.⚠️ <br />
            실제 주문이 접수되오니 주의해 주시기 바랍니다.
            <br /> 잘못된 클릭으로 혼란이 발생할 경우, 당사에서는 책임을 지지 않습니다.
          </h2>
          <button onClick={() => setAuthenticationErrorModal(true)}>테스트 주문 하기</button>
        </div>
        <AlertModal
          isOpen={authenticationErrorModal}
          onCancel={() => setAuthenticationErrorModal(false)}
          onSuccess={testOrder}
          title={`테스트 주문`}
          content={`이 주문은 실제 주문이 아닌 온보딩을 위한 테스트 주문입니다.\n 테스트 주문 버튼을 누르면 포스에 실제로 테스트 주문이 들어갑니다.\n 테스트가 필요할 경우에만 사용해 주세요.`}
          onSuccessText={'테스트 주문'}
          onCloseText={'취소'}
        />
      </Style>
    </>
  );
};

export default StoreTestOrder;

const Style = styled.div`
  h1 {
    font-size: 20px;
    font-weight: 600;
    color: #555;
    margin-bottom: 20px;
  }
  h2 {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: #f04438;
  }

  button {
    margin-top: 50px;
    padding: 10px 24px;
    background: #4dd2ae;
    color: #fff;
    font-size: 20px;
    border-radius: 4px;
  }

  @media (max-width: 500px) {
  }
`;
